module.exports = __webpack_public_path__ + "static/series-land-rover-restoration-3a268e9028cecc7e8d504e497c960eb6.jpg";